import { Link } from "react-router-dom";
import { useSeo } from "@/lib/useSeo";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-display text-lg md:text-lg">{title}</h2>
    <div className="mt-2.5 space-y-2.5 text-sm text-muted-foreground leading-relaxed">{children}</div>
  </section>
);

export const LegalLayout = ({ title, updated, children, testid }) => {
  useSeo({
    title,
    description: `${title} for Houses7.com — how we handle your data and the rules for using our property marketplace.`,
  });
  return (
  <div className="mx-auto max-w-[820px] px-5 md:px-10 py-12" data-testid={testid}>
    <Link to="/" className="text-[13px] font-bold underline">
      Back to home
    </Link>
    <h1 className="mt-5 font-display text-3xl sm:text-4xl">{title}</h1>
    <p className="mt-2 text-[13px] text-muted-foreground">Last updated {updated}</p>
    {children}
    <div className="mt-12 rounded-2xl border border-border p-6">
      <p className="font-display text-[15px]">Questions?</p>
      <p className="mt-1.5 text-sm text-muted-foreground">
        Write to <span className="font-semibold text-foreground">hello@houses7.com</span> and we'll get back to you
        within 3 working days.
      </p>
    </div>
  </div>
  );
};

export { Section as LegalSection };
export default LegalLayout;
